import React, { useState, useRef, useEffect } from "react";
import { Box, TextField, Paper, MenuItem, Chip } from "@mui/material";

const MultiDropDownField = ({
  label,
  disabled,
  value = [],
  options = [],
  onChange,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  // ✅ CLOSE ON OUTSIDE CLICK
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleItem = (item) => {
    let updated;

    if (value.includes(item)) {
      updated = value.filter((v) => v !== item);
    } else {
      updated = [...value, item];
    }

    onChange(updated);
  };

  return (
    <Box ref={wrapperRef} sx={{ position: "relative", mb: 3 }}>
      <TextField
        label={label}
        fullWidth
        value=""
        disabled={disabled} // 👈 same logic
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        InputProps={{
          sx: { borderRadius: 3, cursor: "pointer" },
          readOnly: true,
          startAdornment: (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 1 }}>
              {value.map((item) => (
                <Chip key={item} label={item} size="small" />
              ))}
            </Box>
          ),
        }}
      />

      {open && (
        <Paper
          elevation={4}
          sx={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 6000,
            maxHeight: 250,
            overflowY: "auto",
            borderRadius: 2,
            mt: 0.5,
          }}
        >
          {options.map((item) => {
            const selected = value.includes(item);

            return (
              <MenuItem
                key={item}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleItem(item);
                }}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {item}

                {selected && (
                  <Chip
                    label="✔"
                    size="small"
                    sx={{
                      bgcolor: "success.main",
                      color: "white",
                      fontSize: 10,
                    }}
                  />
                )}
              </MenuItem>
            );
          })}
        </Paper>
      )}
    </Box>
  );
};

export default MultiDropDownField;
